<template>
  <a-modal title="My Vacation"
           :visible="visible"
           width="90%"
           @ok="close"
           @cancel="close"
           :cancel-button-props="{ style: { display: 'none' } }"
  >
    <a-spin :spinning="loading">
      <a-tabs v-model:activeKey="activeTab">
        <a-tab-pane key="vacaciones_pend" :tab="$t('Vacaciones Pendientes por Periodo Anual')">
          <a-table :data-source="infoVacPendientes"
                   :columns="vacPendientesColumns"
                   :pagination="{ pageSize: 5 }"
                   bordered size="small"
                   rowKey="periodoInicio">
            <template slot="diasPendientesRenderer" slot-scope="text, record">
              <span v-if="getTagColor(record)">
                <a-tag color="blue">{{ text }}</a-tag>
              </span>
              <span v-else>
                {{ text }}
              </span>
            </template>
            <template slot="estadoRenderer" slot-scope="text, record">
              <a-tag
                :color="getTagColor(record) || undefined"
                style="font-size: 14px; font-weight: normal"
              >
                {{ getTagColor(record) ? 'En curso' : 'Vencido' }}
              </a-tag>
            </template>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="hist_vacaciones" :tab="$t('Histórico de Vacaciones Disfrutadas')">
          <a-table :data-source="infoHistoricoVac"
                   :columns="historicoVacColumns"
                   :pagination="{ pageSize: 5 }"
                   bordered size="small"
                   rowKey="fechaInicial"></a-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </a-modal>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        activeTab: 'vacaciones_pend',
        loading: false,
        infoVacPendientes: [],
        infoHistoricoVac: [],
        vacPendientesColumns: [
          {
            title: 'Periodo Inicial',
            dataIndex: 'periodo_ini_desc',
            key: 'periodoInicio',
            scopedSlots: {customRender: 'diasPendientesRenderer'}
          },
          {title: 'Periodo Final', dataIndex: 'periodo_fin_desc', key: 'periodoFinal'},
          {
            title: this.$t('Días Pendientes'),
            dataIndex: 'pendientes',
            key: 'diasPendientes',
            scopedSlots: {customRender: 'diasPendientesRenderer'}
          },
          {
            title: 'Estado',
            dataIndex: 'estado',
            key: 'estado',
            scopedSlots: {customRender: 'estadoRenderer'}
          }
        ],
        historicoVacColumns: [
          {
            title: 'Periodo Inicial',
            dataIndex: 'htv_ini_desc',
            key: 'periodoInicio',
            sorter: (a, b) => new Date(a.htv_ini_desc) - new Date(b.htv_ini_desc)
          },
          {
            title: 'Periodo Final',
            dataIndex: 'htv_end_desc',
            key: 'periodoFinal',
            sorter: (a, b) => new Date(a.htv_end_desc) - new Date(b.htv_end_desc)
          },
          {
            title: 'Días Disfrutados',
            dataIndex: 'htv_time',
            key: 'diasDisfrutados',
            sorter: (a, b) => a.htv_time - b.htv_time
          },
          {
            title: 'Días Compensados',
            dataIndex: 'htv_comp',
            key: 'diasCompensados',
            sorter: (a, b) => a.htv_comp - b.htv_comp
          },
          {
            title: 'Fecha Inicio Disfrute',
            dataIndex: 'htv_since_desc',
            key: 'fechaInicial',
            sorter: (a, b) => new Date(a.htv_since_desc) - new Date(b.htv_since_desc)
          },
          {
            title: 'Fecha Fin Disfrute',
            dataIndex: 'htv_to_desc',
            key: 'fechaFinal',
            sorter: (a, b) => new Date(a.htv_to_desc) - new Date(b.htv_to_desc)
          },
          {
            title: 'Año',
            dataIndex: 'year',
            key: 'year',
            sorter: (a, b) => a.year - b.year
          }, {
            title: 'Mes',
            dataIndex: 'mes',
            key: 'mes',
            sorter: (a, b) => a.mes - b.mes
          }, {
            title: 'Periodo',
            dataIndex: 'period_desc',
            key: 'period_desc',
            sorter: (a, b) => a.period_desc - b.period_desc
          }
        ]
      }
    },
    props: ['visible'],
    mounted () {
      this.http = new HttpUtil()
      this.fetchData()
    },
    methods: {
      getTagColor (record) {
        const currentYear = new Date().getFullYear()
        const yearPeriodoIni = parseInt(record.periodo_ini_desc.substring(0, 4), 10)

        if (yearPeriodoIni === currentYear) {
          return 'blue'
        } else {
          return undefined
        }
      },
      close () {
        this.$emit('ok')
      },
      async getInfoVacPendientes () {
        this.loading = true
        this.http.getInstance().get('ss/dashboard/consultar_vac_pendientes', {
          params: {
            code: 1
          }
        }).then((response) => {
          this.infoVacPendientes = response.data
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar los totales empleados, contacte a mesa de ayuda.')
        }).then(() => {
          this.loading = false
        })
      },
      async getInfoHistoricoVac () {
        this.loading = true
        this.http.getInstance().get('ss/dashboard/hist_vac', {
          params: {
            code: 2
          }
        }).then((response) => {
          this.infoHistoricoVac = response.data
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar los totales empleados, contacte a mesa de ayuda.')
        }).then(() => {
          this.loading = false
        })
      },
      async fetchData () {
        this.loading = true
        await Promise.all([
          this.getInfoVacPendientes(),
          this.getInfoHistoricoVac()
        ])
        this.loading = false
      }
    },
    computed: {}
  }
</script>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/ModalMyVacation.vue